<template>
  <div>
    <!-- <div v-if="load_show">
      <load></load>
    </div> -->
    <div class="main">
      <!-- 搜索框 -->
      <el-row >
        <el-input placeholder="搜索提问内容/人员" prefix-icon="el-icon-search" @keyup.enter.native="search_click()" v-model.trim="search" style="width: 90%;margin: 0 5%;"></el-input>
        <el-table
        class="scroll-bar"
          :data="consult_list.data"
          style="width: 90%;margin: 0 5%;  overflow: auto;"
          height="calc(100vh - 200px)"
           >
          <!-- <el-table-column prop="content" sortable label="主题">
          </el-table-column> -->
          <el-table-column prop="num" sortable label="编号" width="100" >
          </el-table-column>
          <el-table-column label="主题" prop="tagNumber" >
              <template slot-scope="scope">
                <el-row style="display: flex; align-items: center;">
                    <el-popover placement="top-start"
                                width="400"
                                trigger="hover"
                                :content="scope.row.content">
                        <div slot="reference" class="twoLineCls">{{scope.row.content}}</div>
                    </el-popover>
                </el-row>
              </template>
          </el-table-column>
          <el-table-column prop="companyee" sortable label="人员" width="100" >
          </el-table-column>
          <el-table-column prop="time" sortable label="时间" width="100" >
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" >
            <template slot-scope="scope">
                <el-button type="text" size="small"  @click="see_info(scope.row.num)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="(consult_list.current_page*1)" :page-sizes="[10, 20, 30, 40]" :page-size="(consult_list.per_page*1)"
            layout="total, sizes, prev, pager, next, jumper" :total="consult_list.total">
          </el-pagination>
        </div>
      </el-row>

    </div>
    <el-dialog  :visible.sync="consult_info.show" width="70%" >
      <!-- <h5>问题{{consult_info.list.title.content}}</h5> -->

      <div style="background-color:rgb(	97, 136, 202);padding: 1.25rem; color: white;" ref="con_h">
        <el-row>
          <el-row >
            <el-popover placement="top-start"
                        width="500"
                        trigger="hover"
                        :content="consult_info.list.title.content">
                <div slot="reference" class="twoLineCls">问题：{{consult_info.list.title.content}}</div>
            </el-popover>
          </el-row>
        </el-row>
        <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
          顾问：{{consult_info.list.title.moderator}}
        </el-row>
        <el-row style="margin-top: 0.625rem; word-wrap:break-word;">
          时间：{{consult_info.list.title.time}}
        </el-row>
      </div>
      <div :style='{height:dialog_height}' class="over" ref="scrollContainer">
        <el-row v-for="(item,index) in consult_info.list.content" :key="index">
          <el-row style="margin-top: 1.25rem;">
            <el-row style="color: #999999;text-align: center; margin: 1.25rem 0; ">
              {{item.time}}
            </el-row>
           <el-row  v-if="item.from==0">
             <el-row style="display: flex;">
               <el-row style="margin-right: 0.625rem; "> {{consult_info.list.title.moderator}}</el-row>
               <el-row style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; " v-html="item.content"></el-row>
             </el-row>
           </el-row>
           <el-row  v-else>
             <el-row style="display: flex;float: right;">
               <el-row style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; " v-html="item.content"></el-row>
               <el-row style="margin-left: 0.625rem;width: 5.25rem;">{{consult_info.list.title.companyee}}</el-row>
             </el-row>
           </el-row>
          </el-row>
        </el-row>
        <el-row  v-if="consult_info.ai">
          <el-row style="text-align: center;margin-top: 0.625rem;color: #909399;">问题已收到，我们将尽快答复</el-row>
          <!-- <el-row style="display: flex;float: right;">
            <el-row style="background-color: #f6f8ff; border-radius: 4px;padding: 0.625rem; ">问题已收到，我们将尽快答复</el-row>
            <el-row style="margin-left: 0.625rem;">我</el-row>
          </el-row> -->
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Header from '../../../../components/index/public/NavHeader.vue';
  // import Footer from '../../../../components/index/public/NavFooter.vue';
  // import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        dialog_height:'',
        consult:{
          show:false,
          input:'',
          value:'',
          type_list:[]
        },
        consult_list:{
          data:[],
          total: 0, // 总条数
          per_page:10,
          current_page:1, // 当前页码
        },
        search: '',
        consult_info:{
          ai:false,
          list:{
          title:{},
          list:[]
          },
          show:false,
          title:'',
          input:'',
          type:'',//分类
        },
      }
    },
    components: {
    },
    mounted:function(){
      this.dialog_height=document.documentElement.clientHeight * 0.5+'px'
      this.get_consult_list()
    },
    methods: {
      handleClose(done) {
      },
      see_info(num){
        let _this=this
        _this.axios.get('/v2/c_consult/consult_info',{params:{num:num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.consult_info.list=res.data.data
              _this.consult_info.show=true
              _this.consult_info.title=res.data.data.title.name
              _this.consult_info.type=res.data.data.title.type
              let type={
                content:res.data.data.title.content,
                from:"1"
              }
              _this.consult_info.list.content.unshift(type)
              if(_this.consult_info.list.content.length==1 || _this.consult_info.list.content[_this.consult_info.list.content.length-1].from!='0'){
                _this.consult_info.ai=true
              }
              // _this.$nextTick(() => {
              //   const container = _this.$refs.scrollContainer;
              //   container.scrollTop = container.scrollHeight;
              // });
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      search_click(){
        let _this=this
        _this.consult_list.per_page=10
        _this.consult_list.current_page=1
        _this.get_consult_list()
      },
      get_consult_list(){
        let _this=this
        console.log(_this.consult_list)
        _this.axios.get('/v2/c_consult/consult_list',{params:{limit:_this.consult_list.per_page,page :_this.consult_list.current_page,keyword:_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.consult_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        let _this=this
        _this.consult_list.current_page = 1;
        _this.consult_list.per_page = val;
        _this.get_consult_list()
        // _this.$router.push({path:'/consult',query:{per_page:val,current_page:1}})
        // _this.$router.go(0)
      },
      handleCurrentChange(val) {
        let _this=this
        _this.consult_list.current_page= val;
        _this.get_consult_list()

        // _this.$router.push({path:'/consult',query:{per_page:10,current_page:val}})
        // _this.$router.go(0)
      },
    },
  }
</script>

<style scoped>
  .twoLineCls{
    cursor: pointer;
  	text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-line-clamp: 2;
       line-clamp: 2;
       -webkit-box-orient: vertical;
  }

  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 40px);
    /* width: 70%; */
    /* padding: 20px; */
    padding:20px;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;

  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
  .over{
    overflow: auto;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(154, 155, 158);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/consult/consult.vue